 import { http } from './http';


export async function listInspections(params = {}) {
    const { data } = await http.get('book/inspections/', { params });
    return data;
}


export async function getInspection(id) {
    const { data } = await http.get(`book/inspections/${id}/`);
    return data;
}


export async function createInspection(payload) {
    
    const { data } = await http.post('book/inspections/', payload);
    return data;
}


export async function updateInspection(id, payload) {
    const { data } = await http.patch(`book/inspections/${id}/`, payload);
    return data;
}


export async function deleteInspection(id) {
    const { data } = await http.delete(`book/inspections/${id}/`);
    return data;
}